// TastyBombs — Main JS
// Slide-out cart drawer + UI interactions

/* ── CART DRAWER ── */

function openCart() {
  document.getElementById('cart-drawer').classList.add('active');
  document.getElementById('cart-overlay').classList.add('active');
  document.body.classList.add('cart-open');
  fetchCart();
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('active');
  document.getElementById('cart-overlay').classList.remove('active');
  document.body.classList.remove('cart-open');
  // Always sync count when closing
  fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});
}

async function fetchCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
  } catch (e) {
    console.error('Cart fetch error:', e);
  }
}

function renderCart(cart) {
  const body = document.getElementById('cart-drawer-body');
  const totalEl = document.getElementById('cart-drawer-total');
  const freeShipEl = document.getElementById('cart-free-ship-msg');

  // Update total
  totalEl.textContent = formatMoney(cart.total_price);

  // Free shipping — always included, clear the msg element
  if (freeShipEl) freeShipEl.innerHTML = '';

  // Empty state
  if (cart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-drawer-empty">
        <div class="cart-drawer-empty-icon">🌶️</div>
        <h3 class="display">Your Cart Is Empty</h3>
        <p>Drop a bomb into your cart and ignite dinner.</p>
        <a href="/collections/all-flavors" onclick="closeCart()">Shop All Flavors →</a>
      </div>`;
    return;
  }

  // Build items HTML
  let itemsHTML = '';
  cart.items.forEach(item => {
    const imgHTML = item.image
      ? `<img src="${item.image}" alt="${item.product_title}">`
      : `<svg width="40" height="40" viewBox="0 0 60 60" fill="none"><circle cx="30" cy="33" r="23" fill="#8B2500"/></svg>`;

    const variantHTML = item.variant_title && item.variant_title !== 'Default Title'
      ? `<div class="cart-drawer-item-variant">${item.variant_title}</div>` : '';

    const sellingPlanHTML = item.selling_plan_allocation
      ? `<div class="cart-drawer-item-selling-plan">🔄 ${item.selling_plan_allocation.selling_plan.name}</div>` : '';

    itemsHTML += `
      <div class="cart-drawer-item" data-key="${item.key}">
        <div class="cart-drawer-item-img">${imgHTML}</div>
        <div>
          <div class="cart-drawer-item-name">${item.product_title}</div>
          ${variantHTML}
          ${sellingPlanHTML}
          <div class="cart-drawer-item-price">${formatMoney(item.final_price)}</div>
          <div class="cart-drawer-qty">
            <button class="cart-drawer-qty-btn" onclick="updateQty('${item.key}', ${item.quantity - 1})">−</button>
            <span class="cart-drawer-qty-val">${item.quantity}</span>
            <button class="cart-drawer-qty-btn" onclick="updateQty('${item.key}', ${item.quantity + 1})">+</button>
          </div>
        </div>
        <div>
          <div class="cart-drawer-item-total">${formatMoney(item.final_line_price)}</div>
          <button class="cart-drawer-item-remove" onclick="removeItem('${item.key}')" aria-label="Remove">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
      </div>`;
  });

  // Upsell products — show if not already in cart
  const handles = cart.items.map(i => i.handle);
  const upsells = [
    {
      handle: 'varietypack',
      title: '8 Flavor Variety Pack',
      subtitle: 'All 8 flavors — save more',
      price: '$174.99',
      img: 'https://tastybombs.com/cdn/shop/files/Variety_22.png?v=1769073639&width=160',
      url: '/products/varietypack'
    },
    {
      handle: 'birriabomb',
      title: 'Birria Balls',
      subtitle: 'The OG. The Legend.',
      price: '$24.99',
      img: 'https://tastybombs.com/cdn/shop/files/PDP_New_1.png?v=1761170061&width=160',
      url: '/products/birriabomb'
    },
    {
      handle: 'potroastballs',
      title: 'Pot Roast Balls',
      subtitle: 'Sunday dinner, simplified.',
      price: '$24.99',
      img: 'https://tastybombs.com/cdn/shop/files/PotRoast.png?v=1768875181&width=160',
      url: '/products/potroastballs'
    }
  ];

  const visibleUpsells = upsells.filter(u => !handles.includes(u.handle));
  const upsellHTML = visibleUpsells.length > 0 ? `
    <div class="cart-drawer-upsells">
      <div class="cart-drawer-upsells-label">You Might Also Love</div>
      ${visibleUpsells.map(u => `
        <div class="cart-drawer-upsell" id="upsell-${u.handle}">
          <div class="cart-drawer-upsell-img">
            <img src="${u.img}" alt="${u.title}" onerror="this.style.display='none'">
          </div>
          <div class="cart-drawer-upsell-text">
            <strong>${u.title}</strong>
            <span>${u.subtitle}</span>
            <span class="cart-drawer-upsell-price">${u.price}</span>
          </div>
          <button class="cart-drawer-upsell-btn" onclick="addUpsell('${u.handle}', this)">Add</button>
        </div>`).join('')}
    </div>` : '';

  body.innerHTML = itemsHTML + upsellHTML;

  // Update header cart count
  updateCartCount(cart.item_count);
}


async function addUpsell(handle, btn) {
  // Show loading state on button
  btn.textContent = '...';
  btn.disabled = true;

  try {
    // Fetch the product to get its first variant ID
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();
    const variantId = product.variants[0].id;

    // Add to cart
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    // Animate the upsell card out then re-render
    const card = document.getElementById(`upsell-${handle}`);
    if (card) {
      card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
      card.style.opacity = '0';
      card.style.transform = 'translateX(20px)';
      setTimeout(async () => {
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        updateCartCount(cart.item_count);
        renderCart(cart);
        showFlash('🔥 Added to cart!');
      }, 300);
    }
  } catch(e) {
    console.error('Upsell add error:', e);
    btn.textContent = 'Add';
    btn.disabled = false;
  }
}

async function updateQty(key, qty) {
  if (qty < 0) return;
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await res.json();
    updateCartCount(cart.item_count);
    renderCart(cart);
  } catch (e) { console.error(e); }
}

async function removeItem(key) {
  await updateQty(key, 0);
}

async function addToCart(variantId, qty = 1, btn = null, sellingPlanId = null) {
  // Button feedback
  if (btn) {
    const orig = btn.innerHTML;
    btn.innerHTML = '✓';
    btn.style.background = '#2ecc71';
    btn.style.transform = 'scale(1.1)';
    setTimeout(() => {
      btn.innerHTML = orig;
      btn.style.background = '';
      btn.style.transform = '';
    }, 1200);
  }

  try {
    const payload = { id: parseInt(variantId), quantity: qty };
    if (sellingPlanId) payload.selling_plan = sellingPlanId;
    console.log('Cart payload:', JSON.stringify(payload));

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const addResult = await res.json();
    console.log('Cart add result:', JSON.stringify(addResult));

    if (addResult.status && addResult.status !== 200) {
      console.error('Cart add error:', addResult.description);
      btn.disabled = false;
      btn.style.opacity = '1';
      return;
    }

    // Show flash
    showFlash('🔥 Added to cart!');

    // Small delay then fetch cart to ensure Shopify has processed the item
    await new Promise(resolve => setTimeout(resolve, 300));
    const cartRes = await fetch('/cart.js?t=' + Date.now());
    const cart = await cartRes.json();
    console.log('Cart after add:', cart.item_count, 'items');
    updateCartCount(cart.item_count);
    renderCart(cart);
    openCart();
  } catch (e) { console.error(e); }
}

function updateCartCount(count) {
  const badge = document.querySelector('.cart-count');
  if (badge) badge.textContent = count;
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function showFlash(msg) {
  let flash = document.getElementById('atc-flash');
  if (!flash) {
    flash = document.createElement('div');
    flash.id = 'atc-flash';
    flash.className = 'atc-flash';
    document.body.appendChild(flash);
  }
  flash.textContent = msg;
  flash.classList.add('show');
  clearTimeout(flash._timer);
  flash._timer = setTimeout(() => flash.classList.remove('show'), 2200);
}

/* ── INTERCEPT ADD TO CART FORMS ── */
document.addEventListener('submit', async function(e) {
  const form = e.target;
  if (form.action && form.action.includes('/cart/add')) {
    e.preventDefault();
    const variantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const sellingPlanInput = form.querySelector('#selling-plan-input');
    const btn = form.querySelector('button[type="submit"]');
    if (variantInput) {
      const sellingPlanId = sellingPlanInput && sellingPlanInput.value ? parseInt(sellingPlanInput.value) : null;
      await addToCart(variantInput.value, qtyInput ? parseInt(qtyInput.value) : 1, btn, sellingPlanId);
    }
  }
});

/* ── INTERCEPT CART ICON ── */
document.addEventListener('click', function(e) {
  const cartLink = e.target.closest('.header-cart');
  if (cartLink) {
    e.preventDefault();
    openCart();
  }
});

/* ── CLOSE ON ESCAPE ── */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeCart();
});

/* ── SCROLL-REVEAL ANIMATIONS ── */
document.addEventListener('DOMContentLoaded', function() {
  // Sync cart count on every page load
  fetch('/cart.js').then(r => r.json()).then(cart => updateCartCount(cart.item_count)).catch(() => {});

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.how-step, .product-card, .review-card, .why-feature, .stat-item').forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(28px)';
    el.style.transition = `opacity 0.5s ease ${i * 0.08}s, transform 0.5s ease ${i * 0.08}s`;
    observer.observe(el);
  });

  /* ── MOBILE MENU ── */
  const menuBtn = document.querySelector('.header-menu-btn');
  const nav = document.querySelector('.header-nav');
  if (menuBtn && nav) {
    menuBtn.addEventListener('click', () => {
      const isOpen = nav.classList.contains('nav-open');
      if (isOpen) {
        nav.classList.remove('nav-open');
        nav.style.display = '';
      } else {
        nav.classList.add('nav-open');
        nav.style.cssText = 'display:flex;flex-direction:column;position:absolute;top:64px;left:0;right:0;background:white;padding:16px 20px;box-shadow:0 8px 32px rgba(0,0,0,0.12);z-index:99;gap:4px;';
      }
    });
  }

  /* ── STICKY HEADER ── */
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 4px 24px rgba(26,10,0,0.15)'
        : '0 2px 20px rgba(26,10,0,0.1)';
    }, { passive: true });
  }

  /* ── PRODUCT GALLERY THUMBNAIL SWITCH ── */
  // Handled inline via pdpSwitch() in product-main.liquid

  /* ── PRODUCT PAGE QTY ── */
  window.changeQty = function(delta) {
    const input = document.getElementById('qty-input');
    if (!input) return;
    let val = parseInt(input.value) + delta;
    if (val < 1) val = 1;
    input.value = val;
  };
});
